// extracted by mini-css-extract-plugin
export default {"root":"Section-root","seoContent":"Section-seoContent","titleWrapper":"Section-titleWrapper","title":"Section-title","description":"Section-description","cta":"Section-cta"};